import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { FaUserLock } from "react-icons/fa";
import "./Login_As_Modal.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";

function Login_As_Modal(props) {
  return (
    <Modal {...props} centered className="login_as_modal_wrapper">
      <Modal.Body>
        <div className="login_as_modal_content">
          <div className="login_as_modal_icon">
            <FontAwesomeIcon icon={faLock} />
          </div>

          <h3 className="login_as_modal_title">Authentication Required</h3>

          <p className="login_as_modal_text">
            {props.text || "Please login to continue"}
          </p>

          <div className="login_as_modal_btn_group">
            <Link to={props.loginRoute} onClick={props.onHide}>
              <button className="login_as_modal_login_btn">Login Now</button>
            </Link>

            <button
              className="login_as_modal_cancel_btn"
              onClick={props.onHide}
            >
              Cancel
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default Login_As_Modal;
